import { IPublicClientApplication, LogLevel, PublicClientApplication } from '@azure/msal-browser';

import { ConfigurationProvider } from '../configuration/ConfigurationProvider';
import { IdentityService } from './IdentityService';

export class IdentityProvider {


    static msalInstance: IPublicClientApplication;

    static async init() {
        let msalInstance = new PublicClientApplication(this.getConfiguration());
        IdentityService.initInstance(msalInstance);
        IdentityProvider.msalInstance = msalInstance;
    }

    static getMsalClient(): IPublicClientApplication {
        return IdentityProvider.msalInstance;
    }

    static getConfiguration() {
        const identityConfig = ConfigurationProvider.getConfiguration().Identity;
        return  ({
            auth: {
                clientId: identityConfig.ClientId,
                authority: identityConfig.Authority,
                knownAuthorities: identityConfig.KnownAuthorities.map(a => a.toLocaleLowerCase()),
                redirectUri: ConfigurationProvider.getConfiguration().App.BaseUrl,
                navigateToLoginRequestUrl: true,
            },
            cache: {
                // sessionStorage (as Identity Web): tokens do not outlive the tab and are not shared with other tabs (R-16).
                cacheLocation: "sessionStorage",
                storeAuthStateInCookie: false,
            },
            system: {
                allowRedirectInIframe: true,
                loggerOptions: {
                    logLevel: LogLevel.Verbose,
                    loggerCallback: (level:any, message:any, containsPii:any) => {

                        if (containsPii) {
                            return;
                        }

                        switch (level) {
                            case LogLevel.Error:
                                console.error(message);
                                return;
                            case LogLevel.Info:
                             //   console.info(message);
                                return;
                            case LogLevel.Verbose:
                               // console.debug(message);
                                return;
                            case LogLevel.Warning:
                                console.warn(message);
                                return;
                        }
                    }
                }
            }
        });
    }




    static getBaseLoginRequest(){
        const identityConfig = ConfigurationProvider.getConfiguration().Identity;

        return ({
            scopes:identityConfig.Scopes
        });
    }


}
